import type { ProyectoPlan } from './tipos'

export const PROYECTOS_INICIALES: ProyectoPlan[] = [
  {
    "id": "proy-1",
    "codigo": "PROY-PLAZA-MERCADO",
    "nombre": "Plaza de Mercado Cartago - Redes e Iluminación",
    "cliente": "Felipe Gonzales",
    "ubicacion": "Cartago, Valle del Cauca",
    "fecha_inicio": "2026-09-23",
    "fecha_fin": "2026-12-23",
    "presupuesto": 595000000,
    "estado": "propuesta",
    "visible_en_matriz": false,
    "notas": null,
    "etapas": [
      {
        "id": "etapa-proy-1-1",
        "proyecto_id": "proy-1",
        "orden": 1,
        "nombre": "Sistema de Puesta a Tierra",
        "fecha_inicio": "2026-09-23",
        "fecha_fin": "2026-12-23",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-1-1-1",
            "etapa_id": "etapa-proy-1-1",
            "codigo": "1.1.1",
            "nombre": "ACTIVIDAD EXCAVACIÓN PARA CABLE DE PUESTA A TIERRA Y/O ADECUACIÓN",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 248,
            "valor_total": 6086050.2,
            "horas": 40,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-1-2",
            "etapa_id": "etapa-proy-1-1",
            "codigo": "1.1.2",
            "nombre": "SUMINISTRO E INSTALACION DE VARILLAS DE COBRE",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 6,
            "valor_total": 3280785.6,
            "horas": 22,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-1-3",
            "etapa_id": "etapa-proy-1-1",
            "codigo": "1.2.1",
            "nombre": "SUMINISTRO E INSTALACION DE CABLE DE COBRE 2/0 AWG",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 248,
            "valor_total": 19092970.79,
            "horas": 64,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 3,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-1-4",
            "etapa_id": "etapa-proy-1-1",
            "codigo": "1.2.2",
            "nombre": "ACTIVIDAD DE FUNDICION MALLA DE TIERRA",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 25,
            "valor_total": 1829543.33,
            "horas": 16,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 4,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-1-2",
        "proyecto_id": "proy-1",
        "orden": 2,
        "nombre": "Apantallamiento (SIPRA)",
        "fecha_inicio": "2026-09-23",
        "fecha_fin": "2026-12-23",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-1-2-1",
            "etapa_id": "etapa-proy-1-2",
            "codigo": "2.1.1",
            "nombre": "SUMINISTRO E INSTALACION DE ALAMBRON DE ALUMINIO 8 mm",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 450,
            "valor_total": 9166963.22,
            "horas": 48,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-2-2",
            "etapa_id": "etapa-proy-1-2",
            "codigo": "2.1.2",
            "nombre": "SUMINISTRO E INSTALACIÓN PUNTAS CAPTADORAS (1 m)",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 10,
            "valor_total": 3160290.8,
            "horas": 18,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-2-3",
            "etapa_id": "etapa-proy-1-2",
            "codigo": "2.2.1",
            "nombre": "SUMINISTRO E INSTALACION DE BAJANTES (GRAPAS BIMETALICAS)",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 2,
            "valor_total": 2413169.21,
            "horas": 12,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 3,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-2-4",
            "etapa_id": "etapa-proy-1-2",
            "codigo": "2.2.2",
            "nombre": "SUMINISTRO E INSTALACION DE TUBERIA EMT/IMC SECCION INSPECCIÓN",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 12,
            "valor_total": 604930.4,
            "horas": 8,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 4,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-1-3",
        "proyecto_id": "proy-1",
        "orden": 3,
        "nombre": "Instalación Interna Locales y Restaurantes",
        "fecha_inicio": "2026-09-23",
        "fecha_fin": "2026-12-23",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-1-3-1",
            "etapa_id": "etapa-proy-1-3",
            "codigo": "3.1.1",
            "nombre": "SUMINISTRO E INSTALACIÓN DE TUBERIA EMT DE 3/4\"",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 250,
            "valor_total": 12879839.68,
            "horas": 56,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-3-2",
            "etapa_id": "etapa-proy-1-3",
            "codigo": "3.2.1",
            "nombre": "SUMINISTRO E INSTALACION CABLE #12 AWG DE ILUMINACION LOCALES",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 500,
            "valor_total": 2339271.9,
            "horas": 24,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-3-3",
            "etapa_id": "etapa-proy-1-3",
            "codigo": "3.2.2",
            "nombre": "SUMINISTRO E INSTALACION CABLE #12 AWG DE FUERZA LOCALES Y RESTAURANTES",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 700,
            "valor_total": 3859344.56,
            "horas": 32,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 3,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-3-4",
            "etapa_id": "etapa-proy-1-3",
            "codigo": "3.3.1",
            "nombre": "SUMINISTRO E INSTALACIÓN DE TOMACORRIENTES",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 121,
            "valor_total": 6484677.17,
            "horas": 40,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 4,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-3-5",
            "etapa_id": "etapa-proy-1-3",
            "codigo": "3.3.2",
            "nombre": "SUMINISTRO E INSTALACION LUMINARIA LOCAL",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 52,
            "valor_total": 6249842,
            "horas": 36,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 5,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-3-6",
            "etapa_id": "etapa-proy-1-3",
            "codigo": "3.3.3",
            "nombre": "SUMINISTRO E INSTALACION DE TOMACORRIENTE GFCI CIRCUITO RESTAURANTE",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 19,
            "valor_total": 1673495.37,
            "horas": 14,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 6,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-3-7",
            "etapa_id": "etapa-proy-1-3",
            "codigo": "3.3.4",
            "nombre": "SUMINISTRO E INSTALACION LUMINARIAS RESTAURANTE E INTERRUPTOR",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 6,
            "valor_total": 1315100.18,
            "horas": 10,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 7,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-1-4",
        "proyecto_id": "proy-1",
        "orden": 4,
        "nombre": "Circuitos Alimentadores y Tableros",
        "fecha_inicio": "2026-09-23",
        "fecha_fin": "2026-12-23",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-1-4-1",
            "etapa_id": "etapa-proy-1-4",
            "codigo": "4.1.1",
            "nombre": "SUMINISTRO E INSTALACION DE TUBERIA PVC 1\", TERMINALES Y CURVAS",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 1918,
            "valor_total": 20905412.81,
            "horas": 72,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-4-2",
            "etapa_id": "etapa-proy-1-4",
            "codigo": "4.2.1",
            "nombre": "SUMINISTRO E INSTALACION DE CIRCUITO ALIMENTADOR CABLE 8 AWG THWN LS HF",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 6900,
            "valor_total": 82673528.25,
            "horas": 96,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-4-3",
            "etapa_id": "etapa-proy-1-4",
            "codigo": "4.3.1",
            "nombre": "SUMINISTRO E INSTALACIÓN DE TABLERO DE DISTRIBUCIÓN 4 CIRCUITOS LOCALES",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 52,
            "valor_total": 10240407.99,
            "horas": 48,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 3,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-4-4",
            "etapa_id": "etapa-proy-1-4",
            "codigo": "4.3.2",
            "nombre": "SUMINISTRO E INSTALACION DE TABLERO DE 4 CIRCUITOS RESTAURANTE",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 6,
            "valor_total": 1204985.54,
            "horas": 12,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 4,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-4-5",
            "etapa_id": "etapa-proy-1-4",
            "codigo": "4.3.3",
            "nombre": "MAMPOSTERIA Y RESANE TABLEROS LOCALES Y RESTAURANTE",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 58,
            "valor_total": 1751310.28,
            "horas": 20,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 5,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-4-6",
            "etapa_id": "etapa-proy-1-4",
            "codigo": "4.3.4",
            "nombre": "SUMINISTRO E INSTALACION DE TABLERO DE ZONAS COMUNES B2",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 1,
            "valor_total": 1746268.06,
            "horas": 14,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 6,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-4-7",
            "etapa_id": "etapa-proy-1-4",
            "codigo": "4.3.5",
            "nombre": "SUMINISTRO E INSTALACION DE TABLERO TRANSFERENCIA Y ZC B2",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 1,
            "valor_total": 21511234.46,
            "horas": 32,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 7,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-4-8",
            "etapa_id": "etapa-proy-1-4",
            "codigo": "4.4.1",
            "nombre": "MARQUILLADO Y ETIQUETAS TABLEROS LOCALES Y RESTAURANTE",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 58,
            "valor_total": 3674480.76,
            "horas": 16,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 8,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-1-5",
        "proyecto_id": "proy-1",
        "orden": 5,
        "nombre": "Red de Comunicaciones (Voz y Datos)",
        "fecha_inicio": "2026-09-23",
        "fecha_fin": "2026-12-23",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-1-5-1",
            "etapa_id": "etapa-proy-1-5",
            "codigo": "5.1.1",
            "nombre": "SUMINISTRO E INSTALACION DE RECAMARAS DE COMUNICACIONES 50X50",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 3,
            "valor_total": 2836718.57,
            "horas": 24,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-5-2",
            "etapa_id": "etapa-proy-1-5",
            "codigo": "5.1.2",
            "nombre": "EXCAVACION Y/O ADECUACION PARA TUBERIA DE COMUNICACIONES",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 45,
            "valor_total": 1931344.03,
            "horas": 18,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-5-3",
            "etapa_id": "etapa-proy-1-5",
            "codigo": "5.1.3",
            "nombre": "SUMINISTRO E INSTALACION DE TUBERIA PVC 1\" CAMARAS-GABINETE",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 60,
            "valor_total": 688574.57,
            "horas": 12,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 3,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-5-4",
            "etapa_id": "etapa-proy-1-5",
            "codigo": "5.1.4",
            "nombre": "SUMINISTRO E INSTALACION DE TUBERIA PVC 3/4\" A CAJAS PAU",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 2400,
            "valor_total": 27542982.74,
            "horas": 64,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 4,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-5-5",
            "etapa_id": "etapa-proy-1-5",
            "codigo": "5.1.5",
            "nombre": "SUMINISTRO E INSTALACION DE CAJAS PAU DE 30X20X10 cm",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 59,
            "valor_total": 5851759.41,
            "horas": 30,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 5,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-1-6",
        "proyecto_id": "proy-1",
        "orden": 6,
        "nombre": "Recámaras de Acometida Subterránea",
        "fecha_inicio": "2026-09-23",
        "fecha_fin": "2026-12-23",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-1-6-1",
            "etapa_id": "etapa-proy-1-6",
            "codigo": "6.1.1",
            "nombre": "SUMINISTRO E INSTALACION DE ETIQUETADO EN ACRILICO PARA CAMARAS",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 3,
            "valor_total": 133878.22,
            "horas": 6,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-6-2",
            "etapa_id": "etapa-proy-1-6",
            "codigo": "6.1.3",
            "nombre": "SUMINISTRO E INSTALACION DE RECAMARAS EEP DE BAJA TENSIÓN",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 3,
            "valor_total": 14202571.13,
            "horas": 40,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-1-7",
        "proyecto_id": "proy-1",
        "orden": 7,
        "nombre": "Acometida Subterránea General 350 kcmil",
        "fecha_inicio": "2026-09-23",
        "fecha_fin": "2026-12-23",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-1-7-1",
            "etapa_id": "etapa-proy-1-7",
            "codigo": "7.1.1",
            "nombre": "SUMINISTRO E INSTALACION DE TUBERIA DE PVC 4\"",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 88,
            "valor_total": 4075850.54,
            "horas": 24,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-7-2",
            "etapa_id": "etapa-proy-1-7",
            "codigo": "7.1.2",
            "nombre": "EXCAVACIÓN Y/O ADECUACIÓN PARA TUBERIA",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 55,
            "valor_total": 1102033.69,
            "horas": 16,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-7-3",
            "etapa_id": "etapa-proy-1-7",
            "codigo": "7.1.3",
            "nombre": "SUMINISTRO E INSTALACION DE CABLE 350 SERIE 8000 LSHF LIBRE DE HALOGENOS",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 450,
            "valor_total": 19452007.55,
            "horas": 48,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 3,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-7-4",
            "etapa_id": "etapa-proy-1-7",
            "codigo": "7.1.4",
            "nombre": "SUMINISTRO E INSTALACION DE SOPORTE Y HERRAJES",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 6,
            "valor_total": 1140156.43,
            "horas": 12,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 4,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-7-5",
            "etapa_id": "etapa-proy-1-7",
            "codigo": "7.1.5",
            "nombre": "SUMINISTRO E INSTALACION DE TUBERIA IMC 4\" ANTI-EXPLOSIVA",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 6,
            "valor_total": 1247830.9,
            "horas": 14,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 5,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-1-8",
        "proyecto_id": "proy-1",
        "orden": 8,
        "nombre": "Gabinete de Medidores 1",
        "fecha_inicio": "2026-09-23",
        "fecha_fin": "2026-12-23",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-1-8-1",
            "etapa_id": "etapa-proy-1-8",
            "codigo": "8.1.1",
            "nombre": "SUMINISTRO E INSTALACION DE GABINETE DE MEDIDORES GABINETE 1",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 1,
            "valor_total": 7652815.58,
            "horas": 20,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-8-2",
            "etapa_id": "etapa-proy-1-8",
            "codigo": "8.2.1",
            "nombre": "SUMINISTRO E INSTALACIÓN DE MEDIDOR CON PIN DE CORTE GABINETE 1",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 24,
            "valor_total": 3446850.15,
            "horas": 24,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-8-3",
            "etapa_id": "etapa-proy-1-8",
            "codigo": "8.3.1",
            "nombre": "SUMINISTRO E INSTALACION DE CABLE ACOMETIDA DEL GABINETE 1",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 36,
            "valor_total": 1592092.39,
            "horas": 14,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 3,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-8-4",
            "etapa_id": "etapa-proy-1-8",
            "codigo": "8.3.2",
            "nombre": "SUMINISTRO E INSTALACION DE TUBERIA PVC GABINETE 1",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 7,
            "valor_total": 157182.5,
            "horas": 8,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 4,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-8-5",
            "etapa_id": "etapa-proy-1-8",
            "codigo": "8.3.3",
            "nombre": "EXCAVACION Y/O ADECUACION TUBERIA ACOMETIDA GABINETE 1",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 7,
            "valor_total": 217386.05,
            "horas": 8,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 5,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-1-9",
        "proyecto_id": "proy-1",
        "orden": 9,
        "nombre": "Gabinete de Medidores 2",
        "fecha_inicio": "2026-09-23",
        "fecha_fin": "2026-12-23",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-1-9-1",
            "etapa_id": "etapa-proy-1-9",
            "codigo": "9.1.1",
            "nombre": "SUMINISTRO E INSTALACION DE GABINETE DE MEDIDORES GABINETE 2",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 1,
            "valor_total": 7652815.58,
            "horas": 20,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-9-2",
            "etapa_id": "etapa-proy-1-9",
            "codigo": "9.2.1",
            "nombre": "SUMINISTRO E INSTALACIÓN DE MEDIDOR CON PIN DE CORTE GABINETE 2",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 24,
            "valor_total": 3446850.15,
            "horas": 24,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-9-3",
            "etapa_id": "etapa-proy-1-9",
            "codigo": "9.3.1",
            "nombre": "SUMINISTRO E INSTALACION DE CABLE ACOMETIDA DEL GABINETE 2",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 36,
            "valor_total": 1103670.03,
            "horas": 14,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 3,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-9-4",
            "etapa_id": "etapa-proy-1-9",
            "codigo": "9.3.2",
            "nombre": "SUMINISTRO E INSTALACION DE TUBERIA PVC GABINETE 2",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 6,
            "valor_total": 134727.86,
            "horas": 8,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 4,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-9-5",
            "etapa_id": "etapa-proy-1-9",
            "codigo": "9.3.3",
            "nombre": "EXCAVACION Y/O ADECUACION TUBERIA ACOMETIDA GABINETE 2",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 6,
            "valor_total": 186330.9,
            "horas": 8,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 5,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-1-10",
        "proyecto_id": "proy-1",
        "orden": 10,
        "nombre": "Gabinete de Medidores 3",
        "fecha_inicio": "2026-09-23",
        "fecha_fin": "2026-12-23",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-1-10-1",
            "etapa_id": "etapa-proy-1-10",
            "codigo": "10.1.1",
            "nombre": "SUMINISTRO E INSTALACION DE GABINETE DE MEDIDORES GABINETE 3",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 1,
            "valor_total": 5452815.58,
            "horas": 18,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-10-2",
            "etapa_id": "etapa-proy-1-10",
            "codigo": "10.2.1",
            "nombre": "SUMINISTRO E INSTALACIÓN DE MEDIDOR CON PIN DE CORTE GABINETE 3",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 11,
            "valor_total": 1579806.32,
            "horas": 16,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-10-3",
            "etapa_id": "etapa-proy-1-10",
            "codigo": "10.2.2",
            "nombre": "SUMINISTRO E INSTALACIÓN DE MEDIDOR TRIFASICO CON PIN DE CORTE",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 1,
            "valor_total": 963755.06,
            "horas": 10,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 3,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-10-4",
            "etapa_id": "etapa-proy-1-10",
            "codigo": "10.3.1",
            "nombre": "SUMINISTRO E INSTALACION DE CABLE ACOMETIDA DEL GABINETE 3",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 28,
            "valor_total": 858410.02,
            "horas": 12,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 4,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-10-5",
            "etapa_id": "etapa-proy-1-10",
            "codigo": "10.3.2",
            "nombre": "SUMINISTRO E INSTALACION DE TUBERIA PVC GABINETE 3",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 5,
            "valor_total": 112273.22,
            "horas": 6,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 5,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-10-6",
            "etapa_id": "etapa-proy-1-10",
            "codigo": "10.3.3",
            "nombre": "EXCAVACION Y/O ADECUACION TUBERIA ACOMETIDA GABINETE 3",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 5,
            "valor_total": 155275.75,
            "horas": 6,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 6,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-1-11",
        "proyecto_id": "proy-1",
        "orden": 11,
        "nombre": "Circuito de Iluminación Locales y Sensores",
        "fecha_inicio": "2026-09-23",
        "fecha_fin": "2026-12-23",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-1-11-1",
            "etapa_id": "etapa-proy-1-11",
            "codigo": "11.1.1",
            "nombre": "SUMINISTRO E INSTALACION DE LUMINARIA",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 27,
            "valor_total": 6297770.61,
            "horas": 28,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-11-2",
            "etapa_id": "etapa-proy-1-11",
            "codigo": "11.1.2",
            "nombre": "SUMINISTRO E INSTALACION DE SENSOR",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 59,
            "valor_total": 7082189.5,
            "horas": 32,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-11-3",
            "etapa_id": "etapa-proy-1-11",
            "codigo": "11.1.3",
            "nombre": "SUMINISTRO E INSTALACION DE TUBERIA LUMINARIA LOCAL",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 270,
            "valor_total": 10963390.36,
            "horas": 44,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 3,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-11-4",
            "etapa_id": "etapa-proy-1-11",
            "codigo": "11.1.4",
            "nombre": "SUMINISTRO E INSTALACION DE CABLE 12 AWG THWN LS HF LIBRE DE HALOGENOS",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 585,
            "valor_total": 2845243.63,
            "horas": 22,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 4,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-1-12",
        "proyecto_id": "proy-1",
        "orden": 12,
        "nombre": "Iluminación de Emergencia",
        "fecha_inicio": "2026-09-23",
        "fecha_fin": "2026-12-23",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-1-12-1",
            "etapa_id": "etapa-proy-1-12",
            "codigo": "12.1.1",
            "nombre": "SUMINISTRO E INSTALACION DE LUMINARIA DE EMERGENCIA 90 MIN AUTONOMIA",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 59,
            "valor_total": 7554448.27,
            "horas": 32,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-12-2",
            "etapa_id": "etapa-proy-1-12",
            "codigo": "12.1.2",
            "nombre": "SUMINISTRO E INSTALACION DE TUBERIA ILUMINACIÓN DE EMERGENCIA",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 130,
            "valor_total": 4932002.76,
            "horas": 28,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-1-13",
        "proyecto_id": "proy-1",
        "orden": 13,
        "nombre": "Iluminación Parqueadero y Baños",
        "fecha_inicio": "2026-09-23",
        "fecha_fin": "2026-12-23",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-1-13-1",
            "etapa_id": "etapa-proy-1-13",
            "codigo": "13.1.1",
            "nombre": "SUMINISTRO E INSTALACION DE CABLE # 12 AWG THWN LS HF",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 1215,
            "valor_total": 5909352.16,
            "horas": 36,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-13-2",
            "etapa_id": "etapa-proy-1-13",
            "codigo": "13.1.2",
            "nombre": "SUMINISTRO E INSTALACION DE LUMINARIAS PARQUEADERO",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 55,
            "valor_total": 12530282.75,
            "horas": 40,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-13-3",
            "etapa_id": "etapa-proy-1-13",
            "codigo": "13.1.3",
            "nombre": "SUMINISTRO E INSTALACION DE TUBERIA EMT 3/4\" ILUMINACIÓN PARQUEADERO",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 270,
            "valor_total": 10098498.78,
            "horas": 38,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 3,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-1-14",
        "proyecto_id": "proy-1",
        "orden": 14,
        "nombre": "Tablero Parqueadero (T.P) y Fuerza",
        "fecha_inicio": "2026-09-23",
        "fecha_fin": "2026-12-23",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-1-14-1",
            "etapa_id": "etapa-proy-1-14",
            "codigo": "14.1.1",
            "nombre": "SUMINISTRO E INSTALACION DE TABLERO DE 12 CIRCUITOS",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 1,
            "valor_total": 656382.18,
            "horas": 10,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-14-2",
            "etapa_id": "etapa-proy-1-14",
            "codigo": "14.1.2",
            "nombre": "SUMINISTRO E INSTALACION DE TUBERIA DE EMT 3/4\"",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 86,
            "valor_total": 3860342.85,
            "horas": 24,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-14-3",
            "etapa_id": "etapa-proy-1-14",
            "codigo": "14.1.3",
            "nombre": "SUMINISTRO E INSTALACION DE TOMACORRIENTES PARQUEADERO",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 6,
            "valor_total": 288939.94,
            "horas": 8,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 3,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-14-4",
            "etapa_id": "etapa-proy-1-14",
            "codigo": "14.1.4",
            "nombre": "SUMINISTRO E INSTALACION DE TOMACORRIENTE GFCI PARQUEADERO",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 4,
            "valor_total": 300699.32,
            "horas": 8,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 4,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-1-15",
        "proyecto_id": "proy-1",
        "orden": 15,
        "nombre": "Planta Eléctrica de Emergencia (75 kVA)",
        "fecha_inicio": "2026-09-23",
        "fecha_fin": "2026-12-23",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-1-15-1",
            "etapa_id": "etapa-proy-1-15",
            "codigo": "15.1.1",
            "nombre": "SUMINISTRO E INSTALACION DE PLANTA ELECTRICA DE 75 KVA",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 1,
            "valor_total": 56006853.66,
            "horas": 48,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-15-2",
            "etapa_id": "etapa-proy-1-15",
            "codigo": "15.1.2",
            "nombre": "SUMINISTRO E INSTALACION DE CABLE DE T.T A PLANTA ELECTRICA DE 75 KVA",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 6,
            "valor_total": 981945,
            "horas": 12,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-15-3",
            "etapa_id": "etapa-proy-1-15",
            "codigo": "15.1.3",
            "nombre": "SUMINISTRO E INSTALACION DE TUBERIA DE GENERADOR A T.T. CONTROL",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 6,
            "valor_total": 338263.52,
            "horas": 10,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 3,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-1-16",
        "proyecto_id": "proy-1",
        "orden": 16,
        "nombre": "Tablero y Circuito Alimentador de Bombas",
        "fecha_inicio": "2026-09-23",
        "fecha_fin": "2026-12-23",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-1-16-1",
            "etapa_id": "etapa-proy-1-16",
            "codigo": "16.1.1",
            "nombre": "SUMINISTRO E INSTALACION DE TABLERO 3 FASES DE 12 CIRCUITOS",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 1,
            "valor_total": 770280.43,
            "horas": 12,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-16-2",
            "etapa_id": "etapa-proy-1-16",
            "codigo": "16.1.2",
            "nombre": "SUMINISTRO E INSTALACION DE TUBERIA DE 1 1/2\"",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 12,
            "valor_total": 933628.8,
            "horas": 10,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-16-3",
            "etapa_id": "etapa-proy-1-16",
            "codigo": "16.1.3",
            "nombre": "SUMINISTRO E INSTALACION DE CABLE A TABLERO DE BOMBAS",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 65,
            "valor_total": 2866576.61,
            "horas": 20,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 3,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-1-17",
        "proyecto_id": "proy-1",
        "orden": 17,
        "nombre": "Circuito Alimentador 4/0 AWG Bloque 1",
        "fecha_inicio": "2026-09-23",
        "fecha_fin": "2026-12-23",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-1-17-1",
            "etapa_id": "etapa-proy-1-17",
            "codigo": "17.1.1",
            "nombre": "SUMINISTRO E INSTALACION DE CABLE 4/0 Y 1/0 SERIE 8000 LSHF GABINETES",
            "descripcion": null,
            "unidad": "GBL",
            "cantidad": 528,
            "valor_total": 12894860.82,
            "horas": 36,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-1-18",
        "proyecto_id": "proy-1",
        "orden": 18,
        "nombre": "Certificaciones RETIE y Trámites OR",
        "fecha_inicio": "2026-09-23",
        "fecha_fin": "2026-12-23",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-1-18-1",
            "etapa_id": "etapa-proy-1-18",
            "codigo": "18.1.1",
            "nombre": "Certificación plena RETIE de uso final y zonas comunes",
            "descripcion": null,
            "unidad": "GBL",
            "cantidad": 1,
            "valor_total": 12000000,
            "horas": 24,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-18-2",
            "etapa_id": "etapa-proy-1-18",
            "codigo": "18.1.2",
            "nombre": "Certificación plena RETIE de ACOMETIDA bornas transformación",
            "descripcion": null,
            "unidad": "GBL",
            "cantidad": 1,
            "valor_total": 4000000,
            "horas": 16,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-18-3",
            "etapa_id": "etapa-proy-1-18",
            "codigo": "18.1.3",
            "nombre": "Tramites de revalidación del proyecto ante el OR",
            "descripcion": null,
            "unidad": "GBL",
            "cantidad": 1,
            "valor_total": 3000000,
            "horas": 16,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 3,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-1-18-4",
            "etapa_id": "etapa-proy-1-18",
            "codigo": "18.1.4",
            "nombre": "CONEXOS",
            "descripcion": null,
            "unidad": "GBL",
            "cantidad": 1,
            "valor_total": 4500000,
            "horas": 12,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 4,
            "orden_trabajo_id": null
          }
        ]
      }
    ]
  },
  {
    "id": "proy-2",
    "codigo": "PROY-BALBOA-MULTIFUNCIONAL",
    "nombre": "Edificación Multifuncional y Cancha - Balboa",
    "cliente": "Municipio de Balboa",
    "ubicacion": "Balboa, Risaralda",
    "fecha_inicio": "2026-09-09",
    "fecha_fin": "2026-11-20",
    "presupuesto": 35360000,
    "estado": "propuesta",
    "visible_en_matriz": false,
    "notas": null,
    "etapas": [
      {
        "id": "etapa-proy-2-1",
        "proyecto_id": "proy-2",
        "orden": 1,
        "nombre": "Acometida, Medición y Puesta a Tierra",
        "fecha_inicio": "2026-09-09",
        "fecha_fin": "2026-11-20",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-2-1-1",
            "etapa_id": "etapa-proy-2-1",
            "codigo": "1.10",
            "nombre": "SUMINISTRO E INSTALACIÓN DE TABLERO PARCIAL TD ZONAS COMUNES 12 CTO",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 1,
            "valor_total": 1220805,
            "horas": 14,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-2-1-2",
            "etapa_id": "etapa-proy-2-1",
            "codigo": "1.20",
            "nombre": "SUMINISTRO E INSTALACIÓN DE SISTEMA DE MEDICIÓN DIRECTA Y PIN DE CORTE",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 1,
            "valor_total": 863036.73,
            "horas": 12,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-2-1-3",
            "etapa_id": "etapa-proy-2-1",
            "codigo": "1.30",
            "nombre": "SUMINISTRO E INSTALACIÓN DE VARILLA CU-CU 5/8 X 2.40 M Y CAJA INSPECCIÓN",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 1,
            "valor_total": 711231.1,
            "horas": 12,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 3,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-2-2",
        "proyecto_id": "proy-2",
        "orden": 2,
        "nombre": "Circuitos Alimentadores e Iluminación",
        "fecha_inicio": "2026-09-09",
        "fecha_fin": "2026-11-20",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-2-2-1",
            "etapa_id": "etapa-proy-2-2",
            "codigo": "2.20",
            "nombre": "SUMINISTRO E INSTALACIÓN DE CIRCUITO ALIMENTADOR EN BAJA TENSIÓN 2F#6+1N#6+1T#8",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 10,
            "valor_total": 730833.41,
            "horas": 10,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-2-2-2",
            "etapa_id": "etapa-proy-2-2",
            "codigo": "2.30",
            "nombre": "SUMINISTRO E INSTALACIÓN DE CIRCUITO DE ILUMINACIÓN 2F#12+T#12 HF-ZH",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 450,
            "valor_total": 5693586.62,
            "horas": 28,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-2-3",
        "proyecto_id": "proy-2",
        "orden": 3,
        "nombre": "Bajantes y Canalizaciones EMT/IMC",
        "fecha_inicio": "2026-09-09",
        "fecha_fin": "2026-11-20",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-2-3-1",
            "etapa_id": "etapa-proy-2-3",
            "codigo": "3.10",
            "nombre": "SUMINISTRO E INSTALACIÓN DE BAJANTES EN TUBERÍA EMT 1/2\" PARA RAMALES",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 132,
            "valor_total": 5085103.72,
            "horas": 36,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-2-3-2",
            "etapa_id": "etapa-proy-2-3",
            "codigo": "3.20",
            "nombre": "SUMINISTRO E INSTALACIÓN DE BAJANTE TUBERÍA 1 1/2\" IMC PARA ACOMETIDA",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 1,
            "valor_total": 335899.88,
            "horas": 8,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-2-3-3",
            "etapa_id": "etapa-proy-2-3",
            "codigo": "3.30",
            "nombre": "TUBERÍA EMT 1 1/2\" PARA CIRCUITO ALIMENTADOR CON ACCESORIOS",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 4,
            "valor_total": 412698.05,
            "horas": 10,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 3,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-2-4",
        "proyecto_id": "proy-2",
        "orden": 4,
        "nombre": "Salidas de Iluminación y Reflectores",
        "fecha_inicio": "2026-09-09",
        "fecha_fin": "2026-11-20",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-2-4-1",
            "etapa_id": "etapa-proy-2-4",
            "codigo": "4.10",
            "nombre": "SALIDA PARA ILUMINACIÓN EN TUBERÍA EMT 1/2\" PARA LÁMPARA HERMÉTICA 2X25W",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 40,
            "valor_total": 5838014.72,
            "horas": 32,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-2-4-2",
            "etapa_id": "etapa-proy-2-4",
            "codigo": "4.20",
            "nombre": "SALIDA PARA LÁMPARA DE EMERGENCIA EN TUBERÍA EMT 1/2\" CON ACCESORIOS",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 9,
            "valor_total": 1251003.31,
            "horas": 12,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-2-4-3",
            "etapa_id": "etapa-proy-2-4",
            "codigo": "4.30",
            "nombre": "SUMINISTRO E INSTALACIÓN DE SALIDA ELÉCTRICA PARA REFLECTOR LED 200W",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 4,
            "valor_total": 2308412.21,
            "horas": 18,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 3,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-2-5",
        "proyecto_id": "proy-2",
        "orden": 5,
        "nombre": "Salidas de Fuerza y Control",
        "fecha_inicio": "2026-09-09",
        "fecha_fin": "2026-11-20",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-2-5-1",
            "etapa_id": "etapa-proy-2-5",
            "codigo": "5.10",
            "nombre": "SALIDA PARA TOMACORRIENTE 110V DOBLE CON POLO A TIERRA EMT 1/2\"",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 10,
            "valor_total": 737381.73,
            "horas": 12,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-2-5-2",
            "etapa_id": "etapa-proy-2-5",
            "codigo": "5.20",
            "nombre": "SALIDA PARA INTERRUPTOR SENCILLO EN TUBERÍA EMT 1/2\"",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 9,
            "valor_total": 646093.55,
            "horas": 10,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-2-5-3",
            "etapa_id": "etapa-proy-2-5",
            "codigo": "5.30",
            "nombre": "SALIDA PARA INTERRUPTOR DOBLE EN TUBERÍA EMT 1/2\"",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 1,
            "valor_total": 73083.17,
            "horas": 4,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 3,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-2-5-4",
            "etapa_id": "etapa-proy-2-5",
            "codigo": "5.40",
            "nombre": "SALIDA PARA TOMACORRIENTE GFCI 110V DOBLE CON POLO A TIERRA",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 1,
            "valor_total": 107038.17,
            "horas": 4,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 4,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-2-5-5",
            "etapa_id": "etapa-proy-2-5",
            "codigo": "5.50",
            "nombre": "SALIDA PARA SENSOR DE MOVIMIENTO EN TUBERÍA EMT 1/2\"",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 4,
            "valor_total": 535001.47,
            "horas": 8,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 5,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-2-6",
        "proyecto_id": "proy-2",
        "orden": 6,
        "nombre": "Certificación RETIE y Legalización OR",
        "fecha_inicio": "2026-09-09",
        "fecha_fin": "2026-11-20",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-2-6-1",
            "etapa_id": "etapa-proy-2-6",
            "codigo": "6.10",
            "nombre": "CERTIFICACIÓN RETIE CON ALCANCE A INSTALACIÓN PÚBLICA",
            "descripcion": null,
            "unidad": "GBL",
            "cantidad": 1,
            "valor_total": 2900000,
            "horas": 20,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-2-6-2",
            "etapa_id": "etapa-proy-2-6",
            "codigo": "6.30",
            "nombre": "TRÁMITES FRENTE A OPERADOR DE RED",
            "descripcion": null,
            "unidad": "GBL",
            "cantidad": 1,
            "valor_total": 600000,
            "horas": 12,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          }
        ]
      }
    ]
  },
  {
    "id": "proy-3",
    "codigo": "PROY-ESTADIO-CAICEDONIA",
    "nombre": "Estadio de Caicedonia - Adecuación Iluminación",
    "cliente": "Consorcio ECA",
    "ubicacion": "Caicedonia, Valle del Cauca",
    "fecha_inicio": "2026-02-06",
    "fecha_fin": "2026-04-15",
    "presupuesto": 108600000,
    "estado": "propuesta",
    "visible_en_matriz": false,
    "notas": null,
    "etapas": [
      {
        "id": "etapa-proy-3-1",
        "proyecto_id": "proy-3",
        "orden": 1,
        "nombre": "Tableros de Control General y Protecciones",
        "fecha_inicio": "2026-02-06",
        "fecha_fin": "2026-04-15",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-3-1-1",
            "etapa_id": "etapa-proy-3-1",
            "codigo": "1.1",
            "nombre": "SUMINISTRO E INSTALACIÓN DE TABLERO DE CONTROL GENERAL Y PROTECCIONES",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 1,
            "valor_total": 7374162,
            "horas": 24,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-3-1-2",
            "etapa_id": "etapa-proy-3-1",
            "codigo": "1.2",
            "nombre": "MONTAJE Y CONEXIÓN DE TABLERO DERIVACIÓN EN POSTE",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 1,
            "valor_total": 1991512.28,
            "horas": 16,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-3-1-3",
            "etapa_id": "etapa-proy-3-1",
            "codigo": "1.3",
            "nombre": "SUMINISTRO E INSTALACIÓN DE TABLERO DE CONTROL SECUNDARIO",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 1,
            "valor_total": 10850398,
            "horas": 28,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 3,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-3-2",
        "proyecto_id": "proy-3",
        "orden": 2,
        "nombre": "Canalización y Tuberías Subterráneas",
        "fecha_inicio": "2026-02-06",
        "fecha_fin": "2026-04-15",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-3-2-1",
            "etapa_id": "etapa-proy-3-2",
            "codigo": "2.1",
            "nombre": "CANALIZACIÓN EN TUBO PVC 2\" PARA ACOMETIDAS DE MÁSTILES",
            "descripcion": null,
            "unidad": "ML",
            "cantidad": 700,
            "valor_total": 10679379.81,
            "horas": 48,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-3-2-2",
            "etapa_id": "etapa-proy-3-2",
            "codigo": "2.2",
            "nombre": "SUMINISTRO E INSTALACIÓN DE CORAZA AMERICANA 1\" CON ACCESORIOS Y CONECTORES",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 8,
            "valor_total": 454687.63,
            "horas": 12,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-3-2-3",
            "etapa_id": "etapa-proy-3-2",
            "codigo": "2.3",
            "nombre": "SUMINISTRO E INSTALACIÓN DE CANALIZACIÓN EN TUBERÍA IMC 3/4\" X 3 METROS",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 33,
            "valor_total": 2911621.46,
            "horas": 26,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 3,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-3-3",
        "proyecto_id": "proy-3",
        "orden": 3,
        "nombre": "Conductores Eléctricos y Acometidas",
        "fecha_inicio": "2026-02-06",
        "fecha_fin": "2026-04-15",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-3-3-1",
            "etapa_id": "etapa-proy-3-3",
            "codigo": "3.7",
            "nombre": "SUMINISTRO E INSTALACIÓN DE CABLE 4 AWG CU",
            "descripcion": null,
            "unidad": "M",
            "cantidad": 115,
            "valor_total": 2554663.78,
            "horas": 18,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-3-3-2",
            "etapa_id": "etapa-proy-3-3",
            "codigo": "3.8",
            "nombre": "SUMINISTRO E INSTALACIÓN DE CABLE 4 AWG AL SERIE 8000",
            "descripcion": null,
            "unidad": "M",
            "cantidad": 186,
            "valor_total": 1591180.66,
            "horas": 16,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-3-3-3",
            "etapa_id": "etapa-proy-3-3",
            "codigo": "3.9",
            "nombre": "SUMINISTRO E INSTALACIÓN DE CABLE 6 AWG AL SERIE 8000",
            "descripcion": null,
            "unidad": "M",
            "cantidad": 437,
            "valor_total": 3100926.69,
            "horas": 22,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 3,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-3-3-4",
            "etapa_id": "etapa-proy-3-3",
            "codigo": "3.10",
            "nombre": "SUMINISTRO E INSTALACIÓN DE CABLE 2 AWG AL SERIE 8000",
            "descripcion": null,
            "unidad": "M",
            "cantidad": 225,
            "valor_total": 2244236.95,
            "horas": 18,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 4,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-3-3-5",
            "etapa_id": "etapa-proy-3-3",
            "codigo": "3.11",
            "nombre": "SUMINISTRO E INSTALACIÓN DE CABLE 1/0 AWG AL SERIE 8000",
            "descripcion": null,
            "unidad": "M",
            "cantidad": 390,
            "valor_total": 5257453.31,
            "horas": 26,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 5,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-3-3-6",
            "etapa_id": "etapa-proy-3-3",
            "codigo": "3.12",
            "nombre": "SUMINISTRO E INSTALACIÓN DE ACOMETIDA CABLE 3X10 CU DESDE CAJA HASTA BORNERA",
            "descripcion": null,
            "unidad": "M",
            "cantidad": 96,
            "valor_total": 3300882.35,
            "horas": 18,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 6,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-3-3-7",
            "etapa_id": "etapa-proy-3-3",
            "codigo": "3.13",
            "nombre": "SUMINISTRO E INSTALACIÓN DE EMPALME DE DERIVACIÓN EN GEL GHFC-2",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 13,
            "valor_total": 1396004.51,
            "horas": 14,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 7,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-3-4",
        "proyecto_id": "proy-3",
        "orden": 4,
        "nombre": "Obra Civil y Cajas de Inspección",
        "fecha_inicio": "2026-02-06",
        "fecha_fin": "2026-04-15",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-3-4-1",
            "etapa_id": "etapa-proy-3-4",
            "codigo": "4.1",
            "nombre": "ACTIVIDAD DE EXCAVACIÓN TIERRA A MANO PARA TENDIDO DE RED",
            "descripcion": null,
            "unidad": "M",
            "cantidad": 305,
            "valor_total": 5701585.96,
            "horas": 40,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-3-4-2",
            "etapa_id": "etapa-proy-3-4",
            "codigo": "4.2",
            "nombre": "CONSTRUCCIÓN DE CAJA ELÉCTRICA DE 0.8 X 0.8 X 1 MT",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 13,
            "valor_total": 6137300.5,
            "horas": 36,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-3-4-3",
            "etapa_id": "etapa-proy-3-4",
            "codigo": "4.3",
            "nombre": "SUMINISTRO E INSTALACIÓN DE TAPA CAJA MARCO ÁNGULO 71X71 - 80X80",
            "descripcion": null,
            "unidad": "UND",
            "cantidad": 13,
            "valor_total": 5216957.22,
            "horas": 20,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 3,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-3-4-4",
            "etapa_id": "etapa-proy-3-4",
            "codigo": "4.4",
            "nombre": "SUMINISTRO E INSTALACIÓN DE RELLENO CON ARENA Y RECEBO COMPACTADO",
            "descripcion": null,
            "unidad": "M3",
            "cantidad": 73,
            "valor_total": 1743238.98,
            "horas": 24,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 4,
            "orden_trabajo_id": null
          }
        ]
      },
      {
        "id": "etapa-proy-3-5",
        "proyecto_id": "proy-3",
        "orden": 5,
        "nombre": "Retiro y Reubicación de Mástiles e Iluminación",
        "fecha_inicio": "2026-02-06",
        "fecha_fin": "2026-04-15",
        "semanas": 2,
        "paralela": false,
        "estado": "por_empezar",
        "orden_trabajo_id": null,
        "modulos": [
          {
            "id": "mod-proy-3-5-1",
            "etapa_id": "etapa-proy-3-5",
            "codigo": "5.1",
            "nombre": "DESMONTE, RETIRO Y TRASLADO DE REFLECTORES EXISTENTES DE MÁSTILES",
            "descripcion": null,
            "unidad": "GLB",
            "cantidad": 1,
            "valor_total": 8500000,
            "horas": 36,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 1,
            "orden_trabajo_id": null
          },
          {
            "id": "mod-proy-3-5-2",
            "etapa_id": "etapa-proy-3-5",
            "codigo": "5.2",
            "nombre": "RETIRO, IZAJE Y REUBICACIÓN EN SITIO DE MÁSTILES DE ILUMINACIÓN DE ESTADIO",
            "descripcion": null,
            "unidad": "GLB",
            "cantidad": 1,
            "valor_total": 14500000,
            "horas": 48,
            "horas_reales": 0,
            "avance": 0,
            "estado": "pendiente",
            "orden": 2,
            "orden_trabajo_id": null
          }
        ]
      }
    ]
  }
]
